import { render, staticRenderFns } from "./icon-alert.vue?vue&type=template&id=6083d25f"
import script from "./icon-alert.vue?vue&type=script&lang=ts"
export * from "./icon-alert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports